export class UserProfile {
    constructor(
        public personalInfo: PersonalInfo,
        public vunetId: string,
        public studentInfo: StudentInfo
    ){}
}

export class Study {
    constructor(
        public studyName: string,
        public facultyName: string
    ){}
}

export class EmailAddress {
    constructor(
        public emailAddress: string,
        public isUniversityEmail: boolean
    ){}
}

export class PhoneNumber {
    constructor(
        public number: string,
        public countryCode: string
    ){}
}

export class Disability {
    constructor(
        public name: string
    ){}
}

export class Address {
    constructor(
        public street: string,
        public houseNumber: string,
        public houseNumberAddition: string,
        public zipcode: string,
        public city: string,
        public country: string,
        public type: string,
        public validFrom: string,
        public validTo: string
    ){}
}

export class Ice {
    constructor(
        public phoneNumbers: PhoneNumber[]
    ){}
}

export class PersonalInfo {
    constructor(
        public firstName: string,
        public callName: string,
        public displayName: string,
        public lastName: string,
        public dateOfBirth: string
    ){}
}

export class StudentInfo {
    constructor(
        public studentNumber: string,
        public emails: EmailAddress[],
        public studies: Study[],
        public addresses: Address[],
        public disabilities: Disability[],
        public phoneNumbers: PhoneNumber[],
        public ice: Ice
    ){}
}
